"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMMEDIATE_QUEUE_ENTRY_RESPONSE_EXAMPLE = exports.QUEUE_TOKEN_RESPONSE_EXAMPLE = exports.APPOINTMENT_QUEUE_RESPONSE_EXAMPLE = exports.VISIT_RESPONSE_EXAMPLE = exports.APPOINTMENT_RESPONSE_EXAMPLE = void 0;
exports.APPOINTMENT_RESPONSE_EXAMPLE = {
    id: '10000000-0000-0000-0000-000000000001',
    appointmentNumber: 'APT2026000123',
    revisitType: null,
    parentAppointmentId: null,
    revisitWaived: false,
    tenantId: '11111111-1111-1111-1111-111111111111',
    branchId: '33333333-3333-3333-3333-333333333333',
    departmentId: '44444444-4444-4444-4444-444444444444',
    doctorId: '22222222-2222-2222-2222-222222222222',
    patientId: '11111111-1111-1111-1111-111111111111',
    bookingChannelId: '55555555-5555-5555-5555-555555555555',
    clinicalPurposeId: null,
    consultationMode: 'IN_PERSON',
    payerContext: 'GENERAL',
    finTariffId: null,
    finPackageId: null,
    finPaymentId: null,
    patientReferralId: null,
    scheduledAt: '2026-08-01T10:00:00.000Z',
    slotNumber: 3,
    durationMinutes: 15,
    priorityTier: 0,
    status: 'PENDING_CONFIRMATION',
    visitId: null,
    version: 1,
    lockVersion: 1,
    createdAt: '2026-07-11T09:00:00.000Z',
    updatedAt: '2026-07-11T09:00:00.000Z',
};
exports.VISIT_RESPONSE_EXAMPLE = {
    id: '20000000-0000-0000-0000-000000000001',
    tenantId: '11111111-1111-1111-1111-111111111111',
    patientId: '11111111-1111-1111-1111-111111111111',
    branchId: '33333333-3333-3333-3333-333333333333',
    episodeId: null,
    visitTypeId: '66666666-6666-6666-6666-666666666666',
    visitNumber: 'VIS000001',
    checkInAt: '2026-08-01T10:05:00.000Z',
    checkOutAt: null,
    createdAt: '2026-08-01T10:05:00.000Z',
    updatedAt: '2026-08-01T10:05:00.000Z',
};
exports.APPOINTMENT_QUEUE_RESPONSE_EXAMPLE = {
    id: '30000000-0000-0000-0000-000000000001',
    tenantId: '11111111-1111-1111-1111-111111111111',
    branchId: '33333333-3333-3333-3333-333333333333',
    departmentId: '44444444-4444-4444-4444-444444444444',
    doctorId: '22222222-2222-2222-2222-222222222222',
    visitId: '20000000-0000-0000-0000-000000000001',
    appointmentId: '10000000-0000-0000-0000-000000000001',
    queueTokenId: '40000000-0000-0000-0000-000000000001',
    priorityTier: 0,
    status: 'WAITING',
    queuedAt: '2026-08-01T10:05:00.000Z',
    calledAt: null,
    completedAt: null,
    lockVersion: 1,
    createdAt: '2026-08-01T10:05:00.000Z',
    updatedAt: '2026-08-01T10:05:00.000Z',
};
exports.QUEUE_TOKEN_RESPONSE_EXAMPLE = {
    id: '40000000-0000-0000-0000-000000000001',
    tenantId: '11111111-1111-1111-1111-111111111111',
    branchId: '33333333-3333-3333-3333-333333333333',
    departmentId: '44444444-4444-4444-4444-444444444444',
    visitId: '20000000-0000-0000-0000-000000000001',
    tokenNumber: 'T-001',
    tokenDate: '2026-08-01',
    issuedAt: '2026-08-01T10:05:00.000Z',
    createdAt: '2026-08-01T10:05:00.000Z',
};
exports.IMMEDIATE_QUEUE_ENTRY_RESPONSE_EXAMPLE = {
    visit: exports.VISIT_RESPONSE_EXAMPLE,
    queueEntry: exports.APPOINTMENT_QUEUE_RESPONSE_EXAMPLE,
};
//# sourceMappingURL=appointment-common.response.js.map